import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=5cd861e0&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=5cd861e0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd861e0')) {
      api.createRecord('5cd861e0', component.options)
    } else {
      api.reload('5cd861e0', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=5cd861e0&", function () {
      api.rerender('5cd861e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DataTable.vue"
export default component.exports